import React, { useState } from "react";
import { Check, ChevronRight, ChevronLeft, PenLine, CheckCircle2 } from "lucide-react";
import { FIELD_LABELS, FIELD_COLORS } from "./ModuloShared";

const ZoomCrop = ({ url, f, sigUrl }) => {
  const [a, setA] = useState(1.414);
  const rw = Math.min(1, Math.max(0.5, f.w + 0.16));
  const rh = Math.min(1, f.h + 0.08);
  const x0 = Math.max(0, Math.min(1 - rw, f.x + f.w / 2 - rw / 2));
  const y0 = Math.max(0, Math.min(1 - rh, f.y + f.h / 2 - rh / 2));
  return (
    <div className="relative w-full overflow-hidden rounded border bg-white" style={{ aspectRatio: `${rw} / ${rh * a}` }} data-testid="modulo-zoom-crop">
      {url && <img src={url} alt="" draggable={false} onLoad={(e) => setA(e.target.naturalHeight / e.target.naturalWidth)} className="absolute max-w-none pointer-events-none"
        style={{ width: `${100 / rw}%`, left: `${(-x0 / rw) * 100}%`, top: `${(-y0 / rh) * 100}%` }} />}
      <div className="absolute pointer-events-none rounded-sm" style={{ left: `${((f.x - x0) / rw) * 100}%`, top: `${((f.y - y0) / rh) * 100}%`, width: `${(f.w / rw) * 100}%`, height: `${(f.h / rh) * 100}%`, border: `2px solid ${FIELD_COLORS[f.type]}`, background: `${FIELD_COLORS[f.type]}22` }}>
        {sigUrl && <img src={sigUrl} alt="Firma" className="w-full h-full object-contain" data-testid="modulo-zoom-sign-img" />}
      </div>
    </div>
  );
};

const Editor = ({ f, value, onChange, signed, onSign, sigKey }) => {
  if (sigKey) {
    const ok = signed.includes(sigKey);
    return <button onClick={() => onSign(f.type)} className="btn-secondary w-full justify-center" data-testid="modulo-zoom-sign" style={{ color: ok ? "#2E7D32" : FIELD_COLORS[f.type] }}>{ok ? <><CheckCircle2 className="w-4 h-4" /> Firmato · rifirma</> : <><PenLine className="w-4 h-4" /> Firma ora</>}</button>;
  }
  if (f.type === "checkbox") {
    return <label className="flex items-center gap-3 text-base p-2 border rounded" data-testid="modulo-zoom-checkbox"><input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} className="w-6 h-6 accent-blue-800" /> {value ? "Selezionata" : "Non selezionata"}</label>;
  }
  return <input autoFocus type={f.type === "date" ? "date" : "text"} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={f.label || FIELD_LABELS[f.type]}
    className="w-full text-base px-3 py-2 border rounded outline-none focus:ring-2 focus:ring-blue-500" data-testid="modulo-zoom-input" />;
};

export const ModuloZoomSheet = ({ fields, idx, url, values, onChange, signed, sigUrl, onSign, sigKeyOf, onGo, onClose }) => {
  const f = fields[idx];
  const last = idx >= fields.length - 1;
  return (
    <div className="fixed inset-0 z-[55] flex flex-col justify-end" style={{ background: "rgba(0,0,0,.45)" }} onClick={onClose} data-testid="modulo-zoom-sheet">
      <div className="bg-white rounded-t-2xl p-4 space-y-3 max-h-[85vh] overflow-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2">
          <div className="font-bold flex-1 truncate" style={{ color: FIELD_COLORS[f.type] }} data-testid="modulo-zoom-label">{f.label || FIELD_LABELS[f.type]}</div>
          <span className="text-xs" style={{ color: "var(--text-muted)" }} data-testid="modulo-zoom-counter">{idx + 1} / {fields.length} · pag. {f.page + 1}</span>
        </div>
        <ZoomCrop key={f.id} url={url} f={f} sigUrl={sigKeyOf(f.type) ? sigUrl : null} />
        <Editor key={`e-${f.id}`} f={f} value={values[f.id]} onChange={(v) => onChange(f.id, v)} signed={signed} onSign={onSign} sigKey={sigKeyOf(f.type)} />
        <div className="flex gap-2">
          <button onClick={() => onGo(idx - 1)} disabled={idx === 0} className="btn-secondary disabled:opacity-40" data-testid="modulo-zoom-prev"><ChevronLeft className="w-4 h-4" /></button>
          <button onClick={onClose} className="btn-secondary flex-1 justify-center" data-testid="modulo-zoom-done"><Check className="w-4 h-4" /> Fatto</button>
          <button onClick={() => (last ? onClose() : onGo(idx + 1))} className="btn-primary flex-1 justify-center" data-testid="modulo-zoom-next">{last ? <><Check className="w-4 h-4" /> Fine</> : <>Avanti <ChevronRight className="w-4 h-4" /></>}</button>
        </div>
      </div>
    </div>
  );
};
